/* eslint-disable react/prop-types */
import React from 'react';
import Modal from './Modal';
import Subscriber from '../../CommonComponents/Subscriber/index';
import './lenderalertmodel.css';

const LenderAlertModel = ({ showModal, handleCloseModal }) => {
  return (
    <Modal
      show={showModal}
      onHide={handleCloseModal}
      className="lender_alert_modal"
      title="Sign Up for Lender Alerts"
      size="md"
    >
      <div className="lender_alert_content">
        <Subscriber />
      </div>
    </Modal>
  );
};

export default LenderAlertModel;